import React from 'react';
import NewReposMessage from './NewRepoMessage';

const UntrackedReposMessage = props => {
  const { extra_data = {} } = props;

  if (!extra_data.repos || !extra_data.sensor_authorization_id) {
    return null;
  }
  const repositories = extra_data.repos;

  return (
    <NewReposMessage
      {...props}
      title={`We are not scanning the following ${repositories.length} ${
        repositories.length === 1 ? 'repository' : 'repositories'
      }:`}
    />
  );
};

export default UntrackedReposMessage;
